'use client'
import React from 'react'
import TitleTemp from './TitleTemp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollar, faFile, faGraduationCap, faMessage } from '@fortawesome/free-solid-svg-icons';

function Step({ 
    icon, 
    title, 
    desc, 
    mainColor, 
    isEnd, 
    // isStart
}) {
    return (
        <div className="relative h-full" style={{ backgroundColor: mainColor }}>
            <div className={`p-8 py-3 text-white h-full  lg:pb-8 ${isEnd==true?'pb-5 lg:pb-0':''}`} >
                <div className='flex items-center gap-2 h-20 -mb-4'>
                    <div className='p-2 w-10 h-10 flex justify-center items-center rounded-md bg-white'>
                        <FontAwesomeIcon icon={icon} color={mainColor} />
                    </div>
                    <h3 className='font-bold text-sm '>{title}</h3>
                </div>

                <div className='text-white text-sm'>
                    {desc}
                </div>
            </div>

            {isEnd ? <></> :
                <svg
                    viewBox="0 0 24 12"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-full h-8 absolute z-10 lg:hidden"
                    preserveAspectRatio="none"
                >
                    <polygon points="0,0 24,0 12,12" style={{ fill: mainColor}} />
                </svg>}
            {isEnd ? <></> :
                <svg
                    viewBox="0 0 12 24"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-full absolute top-0 -right-5 z-10 hidden lg:block"
                    preserveAspectRatio="none"
                >
                    <polygon points="0,0 0,24 12,12" style={{ fill: mainColor }} />
                </svg>}


        </div>
    )
}
export default function TermCondition() {
    return (
        <section id='terms' className='flex flex-col items-center'>
            {/* <TitleTemp name='Terms & Condition' /> */}
            <TitleTemp name='Procedure' />
            <div className='text-sm md:text-base mx-5 w-full  max-w-none lg:mx-0 overflow-hidden grid grid-rows-2 lg:grid-rows-1 lg:grid-cols-4'>
                <Step 
                    icon={faGraduationCap} 
                    title={"Choose Your Competition"} 
                    desc={
                        <p>
                            Select the competition category that matches your study level and interests. To participate in the competition, you must be actively enrolled in your school or university and participating in a formal education program. Proof of enrollment may be requested.
                        </p>
                    }
                    mainColor={"#0ea5e9"} 
                    isEnd={false} 
                    // isStart={true}
                />
                <Step 
                    icon={faFile} 
                    title={"Fill Registration Form"} 
                    desc={
                        <p>
                            To join the IIT Challenge, you must register through the official form. Make sure all required information is filled out accurately. Only registered participants will be considered eligible.
                        </p>
                    }
                    mainColor={"#22b8d6"} 
                    isEnd={false} 
                    // isStart={false} 
                />
                <Step 
                    icon={faDollar} 
                    title={"Registration Fee"} 
                    desc={
                        <p>
                            To complete your IIT Challenge registration, transfer the registration fee to <span className='font-bold'>Bank Central Asia (BCA), KCP BINA NUSANTARA, Account No. 5272163294, under the name Kenneth S R and Williard, </span> as stated in the instructions. <span className='font-bold'> Make sure the amount matches the listed fee and keep the receipt as proof of payment for verification. </span>
                        </p>
                    }
                    mainColor={"#10b981"} 
                    isEnd={false} 
                    // isStart={false} 
                />
                <Step 
                    icon={faMessage} 
                    title={"Join WhatsApp Group"} 
                    desc={
                    <p>
                            After registering for the IIT Challenge, participants and <span className='font-bold'>Person in Charge (PIC)</span> must join the <span className='font-bold'>official WhatsApp group</span> via the link provided at the end of the form. This is mandatory for receiving important updates and announcements.

                    </p>
                    } 
                    mainColor={"#059669"} 
                    isEnd={true} 
                    // isStart={false} 
                />
            </div>
        </section>
    );
}
